module.exports = __webpack_public_path__ + "img/dang.6b392fab.png";